import {
  EmailShareButton,
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
} from 'react-share';
import IconWrapper from '../Icons';
import Tooltip from '../Tooltip';
import styles from './ShareButton.module.scss';

export interface ShareButtonProps {
  url: string;
  shareImageUrl: string;
  emailSubject: string;
  emailBody: string;
  buttonText: string;
}

const ShareButton = ({
  url,
  shareImageUrl,
  emailSubject,
  emailBody,
  buttonText,
}: ShareButtonProps) => {
  const tooltipContents = (
    <>
      <FacebookShareButton url={url}>
        <IconWrapper
          icon="facebook"
          classNames={styles.smIcon}
          fill={'var(--color-gray-dark)'}
          height={18}
        />
      </FacebookShareButton>
      <TwitterShareButton url={url}>
        <IconWrapper
          icon="twitter"
          classNames={styles.smIcon}
          fill={'var(--color-gray-dark)'}
          height={18}
        />
      </TwitterShareButton>
      <PinterestShareButton url={url} media={shareImageUrl}>
        <IconWrapper
          icon="pinterest"
          classNames={styles.smIcon}
          fill={'var(--color-gray-dark)'}
          height={18}
        />
      </PinterestShareButton>
      <EmailShareButton url={url} subject={emailSubject} body={emailBody}>
        <IconWrapper
          icon="mail"
          classNames={styles.smIcon}
          fill={'var(--color-gray-dark)'}
          height={18}
        />
      </EmailShareButton>
    </>
  );

  return (
    <div className={styles.buttonContainer}>
      <Tooltip
        tooltipContents={tooltipContents}
        tooltipId="share-button-tooltip"
        buttonClasses={styles.shareButton}
        popoverClasses={styles.sharePopover}
      >
        <IconWrapper
          icon="share"
          classNames={styles.buttonIcon}
          fill={'var(--color-gray-darker)'}
          width={12}
          height={12}
        />
        <span>{buttonText}</span>
      </Tooltip>
    </div>
  );
};

export default ShareButton;
